import React, { useContext } from 'react';
import { AppContext } from '../../../../common/context/';
import { BaseConfirmModal } from '../BaseConfirmModal';
import { DisassociatedBusinessUnitsProps } from './DisassociatedBusinessUnits.Props';

export const DisassociatedBusinessUnitsModal = ({
    employee,
    endDate,
    isOpen,
    startDate,
    listToDelete,
    onClose,
    onSubmit,
}: DisassociatedBusinessUnitsProps) => {
    const { langResources } = useContext(AppContext);

    const handlerClose = () => {
        onClose(false);
    };

    const handlerSubmit = () => {
        onClose(false);
        onSubmit(listToDelete.map((item) => item.id));
    };

    return (
        <BaseConfirmModal
            isLoading={false}
            modalTitle={langResources['disassociate.business.units.modal']['title']}
            onClose={handlerClose}
            onSubmit={handlerSubmit}
            isOpen={isOpen}
            isShowControls={true}
            textButton={langResources['basemodal.save.button']}
        >
            <div className='modal-body text-dark position-relative'>
                <div
                    className='row '
                    style={{ maxHeight: '50vh', overflowY: 'scroll' }}
                >
                    <table className='table  w-100 text-dark text-center position-relative'>
                        <thead
                            className=' text-black w-100 text-center position-sticky p-0 m-0'
                            style={{ top: '0px', background: '#fff' }}
                        >
                            <tr>
                                <th className='fw-bold'>
                                    {
                                        langResources[
                                            'disassociate.business.units.modal'
                                        ]['employee.label']
                                    }
                                </th>
                                <th className='fw-bold'>
                                    {
                                        langResources[
                                            'disassociate.business.units.modal'
                                        ]['date.label']
                                    }
                                </th>
                                <th className='fw-bold'>
                                    {
                                        langResources[
                                            'disassociate.business.units.modal'
                                        ]['business.units.label']
                                    }
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {listToDelete.map((item) => (
                                <tr key={item.id}>
                                    <th className='p-2 text-start'>
                                        {item.employee}
                                    </th>
                                    <th className='p-2'>{item.date}</th>
                                    <th className='p-2'>
                                        {item.businessUnit?.businessUnitName}
                                    </th>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </BaseConfirmModal>
    );
};
